<template>
  <div>
    <b-row class="d-flex justify-content-center align-items-center">
      <b-col>
        <b-input-group>
          <b-form-input
            v-model="search.keyword"
            :disabled="dataLoading"
            placeholder="Talep no, Talep, Tedarikçi adı ile ara.."
            @keydown.enter="callBack"
          />
          <template #append>
            <b-button
              variant="outline-primary"
              :disabled="dataLoading"
              @click="callBack"
            >
              <feather-icon
                v-if="!dataLoading"
                icon="SearchIcon"
              />
              <b-spinner
                v-if="dataLoading"
                small
              />
            </b-button>
          </template>
        </b-input-group>
      </b-col>
      <b-col md="auto">
        <b-form-checkbox
          v-model="search.detailSearch"
          :disabled="dataLoading"
          switch
        >
          Detaylı Arama
        </b-form-checkbox>
      </b-col>
      <b-col md="auto">
        <div class="text-right">
          <b-button
            variant="primary"
            :to="$route.path + '/add'"
          >
            <FeatherIcon icon="PlusIcon" /> Oluştur
          </b-button>
        </div>
      </b-col>
      <template v-if="search.detailSearch">
        <b-col
          v-if="search.detailSearch"
          cols="12"
          md="12"
        >
          <hr>
        </b-col>
        <b-col
          cols="12"
          md="6"
        >
          <b-form-group
            label="Durum"
            label-for="status"
          >
            <v-select
              id="status"
              v-model="search.id_purchase_offer_status"
              :options="statuses"
              label="title"
              :reduce="item => item.id"
              placeholder="Seçiniz"
            /></b-form-group>
        </b-col>
        <b-col
          cols="12"
          md="6"
        >
          <b-form-group
            label-for="users"
            label="Kullanıcı"
          >
            <v-select
              id="users"
              v-model="search.id_users"
              :options="users"
              label="title"
              :reduce="item => item.id"
              placeholder="Seçiniz"
            /></b-form-group>
        </b-col>
        <b-col
          cols="6"
          md="6"
          class="text-right"
        >
          <b-button
            variant="primary"
            :disabled="dataLoading"
            @click="callBack"
          >
            <feather-icon
              v-if="!dataLoading"
              icon="FilterIcon"
            />
            <b-spinner
              v-if="dataLoading"
              small
            />
            Filtrele
          </b-button>
        </b-col>
        <b-col
          cols="6"
          md="6"
          class="text-left"
        >
          <b-button
            variant="warning"
            :disabled="dataLoading"
            @click="resetFilter"
          >
            <feather-icon
              icon="TrashIcon"
            />
            Sıfırla
          </b-button>
        </b-col>
      </template>
    </b-row>
  </div>
</template>
<script>
import {
  BRow, BCol, BFormInput, BButton, BSpinner, BInputGroup, BFormCheckbox, BFormGroup,
} from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  name: 'PurchaseOfferSearchBar',
  components: {
    BRow, BCol, BFormInput, BButton, BSpinner, BInputGroup, BFormCheckbox, vSelect, BFormGroup,
  },
  props: {
    callBack: {
      type: Function,
      required: true,
    },
  },
  computed: {
    search() {
      return this.$store.getters['purchaseOffers/search']
    },
    dataLoading() {
      return this.$store.getters['purchaseOffers/dataLoading']
    },
    users() {
      return this.$store.getters['users/dataList']
    },
    statuses() {
      return this.$store.getters['purchaseOfferStatus/dataList']
    },
  },
  created() {
    this.getUsers()
    this.getStatuses()
  },
  methods: {
    getUsers() {
      return this.$store.dispatch('users/getDataList', {
        select: [
          'users.id AS id',
          'users.name AS title',
        ],
        where: {
          'users.status': 1,
        },
      })
    },
    getStatuses() {
      return this.$store.dispatch('purchaseOfferStatus/getDataList', {
        select: [
          'purchase_offer_status.id AS id',
          'purchase_offer_status.title AS title',
        ],
      })
    },
    resetFilter() {
      this.$store.commit('purchaseOffers/RESET_SEARCH')
      this.callBack()
    },
  },
}
</script>
